import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import './Auth.css';
import { updateDoc, doc, serverTimestamp, getDoc } from 'firebase/firestore';
import { db } from '../firebase';


const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);

      await updateDoc(doc(db, "users", userCredential.user.uid), {
        lastLoginTime: serverTimestamp()
      });

      // 获取 Firestore 里的 firstName 字段
      const userDocSnap = await getDoc(doc(db, "users", userCredential.user.uid));
      const firstName = userDocSnap.exists() ? userDocSnap.data().firstName : '';

      alert(`Welcome${firstName ? ' ' + firstName : ''}, login successful!`);
      navigate('/');
    } catch (error: any) {
      // 处理各种登录错误情况，提供友好的错误提示
      if (
        error.code === 'auth/invalid-credential' ||
        error.code === 'auth/user-not-found' ||
        error.code === 'auth/wrong-password'
      ) {
        alert('Email or password is incorrect, please try again.');
      } else if (error.code === 'auth/email-already-in-use') {
        // 这个错误理论上不应该在登录时出现，但为了安全起见也处理一下
        alert('This email is already registered. Please sign in with your password, or reset your password if you forgot it.');
      } else if (error.code === 'auth/invalid-email') {
        alert('Invalid email address. Please check and try again.');
      } else if (error.code === 'auth/user-disabled') {
        alert('This account has been disabled. Please contact support.');
      } else if (error.code === 'auth/too-many-requests') {
        alert('Too many failed login attempts. Please try again later or reset your password.');
      } else if (error.code === 'auth/network-request-failed') {
        alert('Network error. Please check your internet connection and try again.');
      } else {
        alert(error.message || 'Login failed. Please try again.');
      }
    }
  };


  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Sign In</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <div className="password-field">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="show-btn"
              onClick={() => setShowPassword(v => !v)}
              tabIndex={-1}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
          <button type="submit">Login</button>
        </form>


        <div style={{ marginTop: 12 }}>
          <Link to="/reset-password" style={{ fontSize: '0.97em', color: '#007bff' }}>
            Forgot password?
          </Link>
        </div>
        <p>
          Don't have an account? <Link to="/register">Register</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;